import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonnePhysiqueContainer extends DivContainer {
	static className = "PersonnePhysiqueContainer";
	
	static properties = {
		exercises : {
			type: Boolean, attribute: "exercises", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		required : {
			type: Boolean, attribute: "required", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};
	
  	constructor (){
	    super();
		this.exercises = false;
		this.required = true;
	    this.content = () => html`
		<row-wrapper>
			<select-field label="Civilité ${this.required ? "*" : ""}" ?required=${this.required} name="id_personne_physique_civilite">
				<option-component label="Choisir" value="0"></option-component>
				<option-component label="Madame" value="1"></option-component>
				<option-component label="Monsieur" value="2"></option-component>
			</select-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Prénom ${this.required ? "*" : ""}" ?required=${this.required} name="first_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Nom ${this.required ? "*" : ""}" ?required=${this.required} name="last_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Adresse ${this.required ? "*" : ""}" ?required=${this.required} name="address"></text-field>
		</row-wrapper>
		<autocomplete-ville required="${this.required}"></autocomplete-ville>
		${this.exercises
		    ? html`
				<row-wrapper>
					<text-field label="Nombre d'exercices ${this.required ? "*" : ""}" ?required=${this.required} name="number_of_exercises" disable-autocomplete></text-field>
				</row-wrapper>
				<row-wrapper>
					<date-field label="Date de fin d'exercice ${this.required ? "*" : ""}" ?required=${this.required} name="date_end_exercises"></date-field>
				</row-wrapper>
		      `
		    : ""}
	    `;
	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("personne-physique", PersonnePhysiqueContainer);
